import {SpotlightActionProps as MantineSpotlightActionProps} from '@mantine/spotlight'
import useStyles from "./SpotlightAction.styles"
import {Badge, Center, Group, Text, UnstyledButton} from "@mantine/core";

export type SpotlightActionProps = MantineSpotlightActionProps & {
    // extend props here
}

export const SpotlightAction = (props: SpotlightActionProps) => {
    const {
        action,
        styles,
        classNames,
        hovered,
        onTrigger,
        ...rest
    } = props

    const {classes} = useStyles(undefined, {styles, classNames, name: 'Spotlight'});

    return (
        <UnstyledButton
            {...rest}
            className={classes.action}
            data-hovered={hovered || undefined}
            tabIndex={-1}
            onMouseDown={(event) => event.preventDefault()}
            onClick={onTrigger}
        >
            <Group noWrap>
                {action.icon && (
                    <Center>
                        {action.icon}
                    </Center>
                )}

                <div style={{flex: 1}}>
                    <Text>{action.title}</Text>

                    {action.description && (
                        <Text color="dimmed" size="xs">
                            {action.description}
                        </Text>
                    )}
                </div>

                {action.active && <Badge color="green">Active</Badge>}
            </Group>
        </UnstyledButton>
    );
}
